import { IKhongDuDieuKienKetQuaHocTapXetTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IKhongDuDieuKienKetQuaHocTapXetTotNghiepActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKhongDuDieuKienKetQuaHocTapXetTotNghiepReducer } from "../../reducer-model/xet-tot-nghiep/IKhongDuDieuKienKetQuaHocTapXetTotNghiepReducer";

const iniState : IKhongDuDieuKienKetQuaHocTapXetTotNghiepReducer = {
    status: eReducerStatusBase.is_not_initialization,
    khongDuDieuKienKetQuaHocTapXetTotNghieps: [],
    selectedIds: [],
}

export const khongDuDieuKienKetQuaHocTapXetTotNghiepReducer = (state: IKhongDuDieuKienKetQuaHocTapXetTotNghiepReducer = iniState, action: IKhongDuDieuKienKetQuaHocTapXetTotNghiepActionTypes): IKhongDuDieuKienKetQuaHocTapXetTotNghiepReducer => {
    switch (action.type) {
        case "KHONG_DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "KHONG_DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                khongDuDieuKienKetQuaHocTapXetTotNghieps: action.payload,
            };
        case "KHONG_DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
      
        default:
            return state;
    }
}